module.exports = __webpack_public_path__ + "img/primo-logo-white.c1998766.png";